import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import PersonService from "../../services/PersonService";
import { SubscriptionService } from "../../services/SubscriptionService";
import Table from "../shared/table";
import Pager from "../../src/View/UI/Pager/Pager";
import { AlertError } from "../../src/View/UI/StandardAlerts/StandardAlerts";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
const NUM_RESULTS = 50;
export default class SubscriptionInfo extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            includeExpired: false,
            subscriber: null,
            subscribee: null,
            subscriberInInput: null,
            subscribeeInInput: null,
            subscriptions: null,
            totalNumSubscriptions: 0,
            subscriptionsLoading: false,
            subscriptionsHasError: false,
            subscriptionErrorMessage: null,
            totalPages: 0,
            currentPage: 0,
            subscriptionsToExpire: [],
            flashMessage: null,
            expireAllSubscriptions: false,
        };
        this.goToPage = (pageNumber) => {
            this.setState({ currentPage: pageNumber, expireAllSubscriptions: false });
            this.getSubscriptionInfo(pageNumber + 1, this.state.subscriber, this.state.subscribee, this.state.includeExpired);
        };
        this.getPeopleOptions = (query) => PersonService.listAsJson(query).then((people) => 
        // $FlowFixMe -- map needing a generic to be declared. Unecessary/impractical to fix
        ({
            options: people.map((person) => ({
                label: person.fullName,
                value: person,
            })),
        }));
        this.getSubscriptionInfo = (pageNumber, subscriber, subscribee, includeExpired) => {
            this.setState({ subscriptionsLoading: true, subscriptionsHasError: false });
            // The &&s here are a more compact way of getting the
            // affiliationId or null if subscribee is null.  Like .? in groovy.
            const subscriberAffiliationId = subscriber && subscriber.affiliationId;
            const subscribeeAffiliationId = subscribee && subscribee.affiliationId;
            SubscriptionService.getSubscriptionInfo(subscriberAffiliationId, subscribeeAffiliationId, includeExpired, (pageNumber - 1) * NUM_RESULTS, NUM_RESULTS)
                .then((result) => this.setState({
                subscriptions: result.data,
                totalNumSubscriptions: result.total,
                totalPages: Math.ceil(result.total / NUM_RESULTS),
            }))
                .catch((error) => this.setState({
                subscriptionsHasError: true,
                subscriptionErrorMessage: error,
            }))
                .finally(() => this.setState({ subscriptionsLoading: false }));
        };
        this.getSubscriptionRow = (subscription) => [
            _jsx("input", { className: "markForExpirationCheckbox", 
                // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
                checked: this.state.subscriptionsToExpire.indexOf(subscription.id) !== -1, onChange: () => this.editToExpirationList(subscription.id), type: "checkbox", value: "", 
                // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'boolean | undefined'.
                disabled: subscription.expirationDate }, 0),
            _jsxs("span", { children: [subscription.student.fullName, " ", _jsxs("span", { className: "text-muted", children: ["(", subscription.student.studentId, ")"] })] }, 0 /* index */),
            subscription.subscriber.fullName,
            subscription.subscriptionType,
            subscription.createdBy.fullName,
            new Date(subscription.createdDate).toLocaleString("en-US"),
            subscription.expiredBy ? (subscription.expiredBy.fullName) : (_jsx("span", { className: "text-muted font-italic", children: "Not expired" })),
            subscription.expirationDate ? (new Date(subscription.expirationDate).toLocaleString("en-US")) : (_jsx("span", { className: "text-muted font-italic", children: "Not expired" })),
            subscription.managingProcesses ? (subscription.managingProcesses.join(", ")) : (_jsx("span", { className: "text-muted font-italic", children: "Not reasons found" })),
        ];
        this.handleGetInfoClick = () => {
            this.setState({
                currentPage: 0,
                subscriber: this.state.subscriberInInput,
                subscribee: this.state.subscribeeInInput,
                subscriptionsToExpire: [],
            });
            this.getSubscriptionInfo(1, this.state.subscriberInInput, this.state.subscribeeInInput, this.state.includeExpired);
        };
        this.handleIncludeExpiredChange = (event) => {
            this.setState({ includeExpired: event.target.checked });
        };
        this.editToExpirationList = (subscriptionId) => {
            const array = [...this.state.subscriptionsToExpire];
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            const index = array.indexOf(subscriptionId);
            if (index !== -1) {
                // remove from subscriptionsToExpire
                array.splice(index, 1);
                this.setState({
                    expireAllSubscriptions: false,
                    subscriptionsToExpire: array,
                });
            }
            else {
                // add to subscriptionsToExpire
                this.setState({
                    subscriptionsToExpire: this.state.subscriptionsToExpire.concat(
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    subscriptionId),
                });
            }
        };
        this.expireSubscriptions = (event) => {
            if (
            // eslint-disable-next-line no-alert
            !window.confirm("Are you sure you want to expire " +
                this.state.subscriptionsToExpire.length +
                (this.state.subscriptionsToExpire.length === 1
                    ? " relationship?"
                    : " relationships?") +
                "  This action cannot be undone.")) {
                return;
            }
            SubscriptionService.expireSubscriptions(this.state.subscriptionsToExpire)
                .then((response) => {
                this.setState({
                    subscriptionsToExpire: [],
                    flashMessage: response.message,
                });
                this.handleGetInfoClick();
            })
                .catch((error) => this.setState({
                subscriptionsHasError: true,
                subscriptionErrorMessage: error,
            }))
                .finally(() => this.setState({ subscriptionsLoading: false }));
        };
        this.resetFlashMessage = () => {
            this.setState({ flashMessage: null });
        };
        this.toggleAllForExpiration = (event) => {
            if (!this.state.expireAllSubscriptions) {
                // @ts-expect-error - TS2488 - Type 'null' must have a '[Symbol.iterator]()' method that returns an iterator.
                const subs = [...this.state.subscriptions];
                let subsToAdd = subs
                    .filter((sub) => !sub.expirationDate &&
                    // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
                    [...this.state.subscriptionsToExpire].indexOf(sub.id) === -1)
                    .map((sub, index) => sub.id);
                subsToAdd = subsToAdd.concat([...this.state.subscriptionsToExpire]);
                this.setState({
                    expireAllSubscriptions: true,
                    subscriptionsToExpire: subsToAdd,
                });
            }
            else {
                this.setState({
                    expireAllSubscriptions: false,
                    subscriptionsToExpire: [],
                });
            }
        };
    }
    render() {
        return (_jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsxs("h1", { className: "title", children: ["Relationships", " ", this.state.subscriptions &&
                                    "(" + this.state.totalNumSubscriptions + ")"] }) }) }), _jsx("div", { role: "main", children: _jsxs("div", { children: [this.state.flashMessage && (_jsxs("div", { className: "alert alert-success alert-dismissible fade in mb-2", role: "alert", children: [_jsx("button", { type: "button", className: "close", "aria-label": "Close", onClick: this.resetFlashMessage, children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) }), _jsx("span", { className: "fa fa-check mr-2" }), this.state.flashMessage] })), _jsx("div", { className: "alert alert-warning", role: "alert", children: "Learn more about why your staff may be following certain people. To get started, select a Success Staff Member or a Student (or both) below and press \"Search\" to view the data Aviso has about the relationships involving these people." }), _jsxs("div", { className: "row align-items-center", children: [_jsx("div", { className: "col-md-4", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "fromPerson", children: "Success Staff Member" }), _jsx(DeprecatedSelect.Async, { id: "fromPerson", "aria-label": "Success Staff Member", loadOptions: this.getPeopleOptions, onChange: (val) => this.setState({ subscriberInInput: val && val.value }), value: this.state.subscriberInInput && {
                                                        // @ts-expect-error - TS2339 - Property 'fullName' does not exist on type 'never'.
                                                        label: this.state.subscriberInInput.fullName,
                                                        value: this.state.subscriberInInput,
                                                    }, inputProps: { autoComplete: "off" } }), _jsx("small", { className: "text-muted", children: "The person receiving events and alerts about the student." })] }) }), _jsx("div", { className: "col-md-4", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "fromPerson", children: "Student" }), _jsx(DeprecatedSelect.Async, { "aria-label": "Student", id: "fromPerson", loadOptions: this.getPeopleOptions, onChange: (val) => this.setState({ subscribeeInInput: val && val.value }), value: this.state.subscribeeInInput && {
                                                        // @ts-expect-error - TS2339 - Property 'fullName' does not exist on type 'never'.
                                                        label: this.state.subscribeeInInput.fullName,
                                                        value: this.state.subscribeeInInput,
                                                    }, inputProps: { autoComplete: "off" } }), _jsx("small", { className: "text-muted", children: "The person the events/alerts are about." })] }) }), _jsx("div", { className: "col-md-2", children: _jsx("div", { className: "form-group text-center", children: _jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { id: "chkExpired", checked: this.state.includeExpired, className: "custom-control-input", onChange: this.handleIncludeExpiredChange, type: "checkbox", value: "" }), _jsx("label", { className: "custom-control-label", htmlFor: "chkExpired", children: "Include Expired" })] }) }) }), _jsx("div", { className: "col-md-2", children: _jsx("div", { className: "form-group", children: _jsxs("button", { className: "btn btn-primary", disabled: this.state.subscriptionsLoading ||
                                                    (!this.state.subscriberInInput &&
                                                        !this.state.subscribeeInInput), onClick: this.handleGetInfoClick, children: [_jsx("span", { className: this.state.subscriptionsLoading
                                                            ? "fa fa-circle-notch fa-spin"
                                                            : "fas fa-search", "aria-hidden": true }), "\u00A0Search"] }) }) })] }), this.state.subscriptionsHasError && (_jsx(AlertError, { message: "There was an error loading relationships.  Please try again.  If the error persists, contact support", detail: this.state.subscriptionErrorMessage })), this.state.subscriptions && (_jsxs("div", { children: [_jsx("div", { children: _jsxs("button", { className: "btn btn-danger mb-2", onClick: this.expireSubscriptions, disabled: !this.state.subscriptionsToExpire.length, children: ["Expire Relationships (", this.state.subscriptionsToExpire.length, ")"] }) }), _jsx(Table, { headers: [
                                            _jsx("input", { className: "markForExpirationCheckbox", checked: this.state.expireAllSubscriptions, onChange: this.toggleAllForExpiration, type: "checkbox", value: "" }, 0),
                                            "Student",
                                            "Staff Member",
                                            "Relationship Type",
                                            "Created By",
                                            "Created Date",
                                            "Expired By",
                                            "Expiration Date",
                                            "Reasons",
                                        ], 
                                        // @ts-expect-error - TS2339 - Property 'map' does not exist on type 'never'.
                                        rows: this.state.subscriptions.map(this.getSubscriptionRow) }), _jsx("div", { children: _jsxs("div", { className: "d-flex align-items-center", children: [_jsx(Pager, { totalPages: this.state.totalPages, setCurrentPage: this.goToPage, currentPage: this.state.currentPage }), this.state.subscriptionsLoading &&
                                                    this.state.totalPages > 1 && (_jsx("div", { className: "d-flex ml-2", children: _jsx("span", { className: "fa fa-lg fa-circle-notch fa-spin text-muted", "aria-hidden": true }) }))] }) })] }))] }) })] }));
    }
}
